var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TreeArticle',{attrs:{"article":_vm.article,"entity-id":_vm.entityId,"type":_vm.type,"count":_vm.overallTotal,"showDelete":_vm.moment(_vm.date).format('YYYYMM') >= _vm.moment().format('YYYYMM')},on:{"remove":_vm.removeArticle,"updateInterval":_vm.updateInterval}})
}
var staticRenderFns = []

export { render, staticRenderFns }